/**
 * Visuals Module - Barrel Export
 * Central export point for all visual components and utilities
 */

// Types — explicit named exports (no wildcard)
export type { VisualAidType, VisualAid, MoneyVisualData, MoneyBreakdown, ColumnVisualData, VerbTableData, KofschipMnemonicData, SyllableBlocksData } from './types';
export { VISUAL_AID_TYPES } from './types';

// Registry — explicit named exports (no wildcard)
export { VISUAL_REGISTRY, getVisualComponent } from './registry/visualRegistry';

// Components
export { VisualAidFactory, shouldShowVisualAid, VISUAL_AID_FACTORY_SUPPORTED_TYPES, SUPPORTED_VISUAL_AID_TYPES } from './components/VisualAidFactory';

// Individual visual components (used directly by renderers)
export { AnalogClock } from './components/AnalogClock';
export { GeometricShape } from './components/GeometricShape';
export { CalendarVisual } from './components/CalendarVisual';
export { PercentageBar } from './components/PercentageBar';
export { FractionStrip } from './components/FractionStrip';
export { SplitDiagram } from './components/SplitDiagram';
export { SentenceDiagram } from './components/SentenceDiagram';
export { MapScale } from './components/MapScale';
export { Protractor } from './components/Protractor';
export { SymmetryGrid } from './components/SymmetryGrid';
export { NumberBoard } from './components/NumberBoard';
export { SpeedDiagram } from './components/SpeedDiagram';
export { PriceCompare } from './components/PriceCompare';
export { Timeline } from './components/Timeline';
export { WorldClockPanel } from './components/WorldClockPanel';